import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import InstagramFeed from '@/components/InstagramFeed';

const API = process.env.REACT_APP_BACKEND_URL;

export default function GalleryPage() {
  const [artworks, setArtworks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArtworks = async () => {
      try {
        const { data } = await axios.get(`${API}/api/artworks`);
        setArtworks(data);
      } catch (error) {
        console.error('Error fetching artworks:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchArtworks();
  }, []);

  return (
    <div className="page-transition pt-28">
      {/* Header */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-12">
        <div className="max-w-3xl">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#525252] block mb-2">
            Collection
          </span>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[#F5F5F0] tracking-tighter leading-none mb-6">
            Exhibitions
          </h1>
          <p className="text-[#A3A3A3] text-base leading-relaxed">
            Each piece represents a moment of truth — where emotion 
            meets canvas, and the invisible becomes visible.
          </p>
        </div>
      </section>

      {/* Gallery Grid — editorial cards linking to exhibition pages */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-16">
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="aspect-square skeleton" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {artworks.map((artwork, index) => (
              <Link
                key={artwork.id}
                to={`/exhibition/${artwork.id}`}
                className="group block"
                data-testid={`gallery-artwork-${index}`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={artwork.image_url}
                    alt={artwork.title}
                    className="w-full h-[400px] object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#C5A059] mb-2 block">
                      {artwork.medium || 'Artwork'}
                    </span>
                    <h3 className="font-serif text-xl md:text-2xl text-[#F5F5F0] leading-tight mb-1">
                      <strong>{artwork.title}</strong>
                    </h3>
                    <p className="text-[#A3A3A3] text-xs font-mono">
                      {artwork.year}{artwork.dimensions ? ` · ${artwork.dimensions}` : ''}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>

      {/* Instagram Feed */}
      <InstagramFeed />
    </div>
  );
}
